import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/system';
import { Trans } from 'react-i18next';

interface CodeValueOutOfRangeDialogProps {
  open: boolean;
  header: string;
  label: React.ReactNode;
  min: number;
  max: number;
  onClose: () => void;
}

const CodeValueOutOfRangeDialog = ({ header, label, min, max, onClose }: CodeValueOutOfRangeDialogProps) => {
  const handleCodeValueOutOfRange = () => {
    onClose();
  };

  return (
    <>
      <DialogTitle variant="dialogTitle" align="center">
        <Trans i18nKey="codeValueOutOfRangeDialog.title">Warning</Trans>
      </DialogTitle>
      <Divider />
      <DialogContent style={{ padding: '3rem 2.75rem' }}>
        <Stack direction="column" spacing={2} useFlexGap flexWrap="wrap">
          <Typography variant="dialogTitle">
            {label}
            <Trans i18nKey="codeValueOutOfRangeDialog.header">
              The value you entered for the {{ label }} parameter on the {{ header }} component is out of range. Please enter a value between{' '}
              {{ min }} and {{ max }}.
            </Trans>
          </Typography>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions style={{ justifyContent: 'center', margin: '2px 0' }}>
        <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
          <Button variant="contained" autoFocus onClick={handleCodeValueOutOfRange}>
            <Trans i18nKey="codeValueOutOfRangeDialog.button.ok">Ok</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};

export default CodeValueOutOfRangeDialog;
